import Icon from '../components/Icon.vue'

Icon.register({
  dragon: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M18.3 255.8c-16 2.3-24.9-17.8-12.5-28.1l117.4-116.3c21.8-18.6 53.2-20.5 77.1-4.6l119.7 87.6v42.3c0 28.9 5.3 57 14.7 83.4h-222.7c-14.3 0-21.4-17.2-11.3-27.3l91.3-68.7zM575.2 289.9c41.9 21 67.2 64.1 64.6 111.4-3.4 63.2-59.7 110.8-123 110.8h-499.1c-9.8 0-17.8-8-17.8-17.8 0-8.3 5.8-15.5 13.9-17.3 89.5-19.9 238.5-54.1 434.1-60.9-60-40-96-107.3-96-179.4v-108.6l-59.6-24.8c-5.9-3-5.9-11.4 0-14.3l59.6-24.8-61.6-50.3c-5-5-1.5-13.6 5.7-13.6h237.4c10.1 0 19.5 4.7 25.6 12.8l74.5 99.4c3.5 4.7 6.4 13.3 6.4 19.2 0 4.2-1.5 10.6-3.4 14.3l-14.3 28.6c-4.9 9.8-17.7 17.7-28.6 17.7h-31c-8.5 0-16.6-3.4-22.6-9.4l-28.1-22.6h-64v36.7c0 16.4 11.9 35.6 26.5 42.9zM489.2 66.3c-4.3 17.1 8.6 29 21.5 29.7 11.7 0.6 21.4-7.3 24.1-18.3z'
      }
    ]
  }
})
